// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3696":"7136cf1a","4526":"eaf46ba3","5847":"7136cf1a","7084":"9d0fca24","7967":"7136cf1a"}[chunkId] + ".chunk.css";
};